import { z } from 'zod';

import { chatEventIdSchema, chatMessageIdSchema, chatThreadIdSchema } from './chat-ids';
import { structuredResponseEventSchema } from './structured-tools';

export const errorPayloadSchema = z.object({
    code: z.string(),
    message: z.string(),
});

export type ErrorPayload = z.infer<typeof errorPayloadSchema>;

export const messageStartEventSchema = z.object({
    eventId: chatEventIdSchema,
    eventType: z.literal('message-start'),
    messageId: chatMessageIdSchema,
    threadId: chatThreadIdSchema,
    timestamp: z.string(),
});

export type MessageStartEvent = z.infer<typeof messageStartEventSchema>;

export const completeEventSchema = z.object({
    eventId: chatEventIdSchema,
    eventType: z.literal('complete'),
    messageId: chatMessageIdSchema,
    threadId: chatThreadIdSchema,
    timestamp: z.string(),
});

export type CompleteEvent = z.infer<typeof completeEventSchema>;

export const errorEventSchema = z.object({
    eventId: chatEventIdSchema,
    eventType: z.literal('error'),
    messageId: chatMessageIdSchema,
    payload: errorPayloadSchema,
    threadId: chatThreadIdSchema,
    timestamp: z.string(),
});

export type ErrorEvent = z.infer<typeof errorEventSchema>;

// Outer envelope is a plain `z.union` (not `z.discriminatedUnion`) because
// `structuredResponseEventSchema` is itself a discriminated union and cannot
// be nested as a member of a `discriminatedUnion`.
export const sseEnvelopeSchema = z.union([
    messageStartEventSchema,
    structuredResponseEventSchema,
    completeEventSchema,
    errorEventSchema,
]);

export type SseEnvelope = z.infer<typeof sseEnvelopeSchema>;

export type ChunkEvent = {
    readonly eventId: string;
    readonly eventType: 'chunk';
    readonly text: string;
};

export type ChatStreamEvent = ChunkEvent | SseEnvelope;
